import { render, staticRenderFns } from "./StampModal.vue?vue&type=template&id=6681e0ae&scoped=true&"
import script from "./StampModal.vue?vue&type=script&lang=ts&"
export * from "./StampModal.vue?vue&type=script&lang=ts&"
import style0 from "./StampModal.vue?vue&type=style&index=0&id=6681e0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681e0ae",
  null
  
)

export default component.exports